import request from "@/utils/request";

export function getTalkUserList(data) {
  return request({
    url:'/socket/talk/getTalkUserList',
    method: 'post',
    headers: {
      "hideLoading": true
    },
    data
  })
}

export function startTalk(data){
  return request({
    url:'/socket/talk/startTalk',
    method: 'post',
    headers: {
      "hideLoading": true
    },
    data
  })
}

export function getTalkHistory(data){
  return request({
    url:'/socket/talk/getTalkHistory',
    method: 'post',
    headers: {
      "hideLoading": true
    },
    data
  })
}

export function onLineState(data){
  return request({
    url:'/socket/talk/onLineState',
    method: 'post',
    headers: {
      "hideLoading": true
    },
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/talk.js